import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

/**
 * Texts of Çalışan Finans Yönetimi and its dialogs (`employeeFinance.*`).
 * `formatMoney` shows amounts in ₺ in the UI language; stored values and the
 * Excel file stay as they were.
 */
const useEmployeeFinanceText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`employeeFinance.${key}`, vars), [t]);
  const formatMoney = useCallback((value) => {
    const number = Number(value);
    return `${(Number.isFinite(number) ? number : 0).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
  }, [locale]);
  const formatDate = useCallback((value) => {
    if (!value) return '-';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString(locale);
  }, [locale]);
  return { t, language, locale, label, formatMoney, formatDate };
};

export default useEmployeeFinanceText;
